import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { relationshipStoreActions, RootStoreState } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { DocumentService } from '@app/shared/services';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import * as selectors from '../../../root-store/relationship-store/relationship.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'select-user-from-network',
  templateUrl: './select-user-from-network.component.html',
  styleUrls: ['./select-user-from-network.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectUserFromNetworkComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedOption = 'Last Added';
  @ViewChild('search') searchElement: ElementRef;
  filterString = '';
  connectedUserinPolicy = false;
  currentDate;
  getAllClientGroups$;
  clientGroups = [];
  datas = [];
  user;
  impersonateUserIdForReport = false;
  searchString: FormControl;
  currentFormId;
  subscription = new Subscription();
  text = 'reminder';
  ownerUserProfile = {
    id: '',
    name: '',
    image: '',
  };
  currentFormIdList = [];
  vaultStateObject;
  entitiesItems;
  constructor(
    private store$: Store<RootStoreState.State>,
    private store: Store,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,
    private documentService: DocumentService,
    private vaultService: VaultStoreEffects,
    public dialogRef: MatDialogRef<SelectUserFromNetworkComponent>
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        } else {
          this.user = null;
        }
      })
    );
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
      })
    );
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      this.searchElement.nativeElement.focus();
    }, 0);
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  grantPermission(item, i) {
    let currentfomtList = this.currentFormIdList.length > 0 ? this.currentFormIdList : [this.currentFormId];
    const request = {
      formids: currentfomtList,
      user_id: item.user_id,
    };
    this.subscription.add(
      this.documentService.grantPermission(request).subscribe((res) => {
        if ((res.status = 'success')) {
          const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
          this.dialogRef.close({
            isSuccess: true,
            item: data,
          });
        }
      })
    );
  }
  openFolder(item, i) {
    if (item.user_id == this.data.userId) return;
    if (this.data.isAlreadyGrant) {
      const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
      this.dialogRef.close({
        isSuccess: true,
        item: data,
      });
      return;
    }

    this.clientGroups.forEach((element, index) => {
      this.clientGroups[index].isAccess = true;
    });

    this.clientGroups[i].isRunning = true;
    this.cd.detectChanges();
    let currentfomtList = this.currentFormIdList.length > 0 ? this.currentFormIdList : [this.currentFormId];
    this.subscription.add(
      this.documentService.checkUserHasFormAccess(item.user_id, currentfomtList).subscribe((res) => {
        this.clientGroups[i].isRunning = false;
        this.clientGroups[i].isAccess = res.access;

        if (res.access) {
          const data = { id: item.user_id, name: item.user_first_middle_name + ' ' + item.user_last_name, image: item.user_profile_image_url };
          this.dialogRef.close({
            isSuccess: true,
            item: data,
          });
        }
        this.cd.detectChanges();
      })
    );
  }
  addLoginUser() {
    if (this.ownerUserProfile?.id == this.data.userId) return;
    const data = { id: this.ownerUserProfile.id, name: this.ownerUserProfile.name, image: this.ownerUserProfile.image };
    this.dialogRef.close({
      isSuccess: true,
      item: data,
    });
  }
  ngOnInit(): void {
    this.currentFormId = this.data.currentFormId;

    if (this.data?.type == 'task') {
      this.text = 'task';
    }
    if (this.data?.currentFormIdList) {
      this.text = 'reminder/task(s)';
      this.currentFormIdList = this.data?.currentFormIdList;
    }
    this.ownerUserProfile = this.data.loginOwnerUserProfile;

    if (this.data?.impersonateUserIdForReport) {
      this.impersonateUserIdForReport = true;
    }
    if (this.data.type != 'entity') this.getFilterData();
    if (this.data.type == 'entity') this.getFormUserFormAssociation();
    this.searchString = new FormControl();
    this.subscription.add(
      this.searchString.valueChanges.subscribe((res) => {
        this.filterString = res;

        this.datas.push(this.ownerUserProfile);
        if (this.data.type != 'entity') this.getFilterData();
        if (this.data.type == 'entity') this.getFormUserFormAssociation();
      })
    );
  }
  getFilterData() {
    if (this.data.policy) {
      this.connectedUserinPolicy = this.data.members.some((obj) => obj.userid === this.ownerUserProfile.id);
      this.subscription.add(
        this.store$.pipe(select(selectors.getAndFilterAllUsers(this.filterString))).subscribe((res) => {
          const newArr = res
            .filter((item) => {
              return this.data.members.every((filterItem) => filterItem.userid != item.user_id);
            })
            .map((element) => ({
              ...element,
              isAccess: true,
              connection_status: 'approved',
            }));
          this.clientGroups = newArr;
          this.cd.detectChanges();
        })
      );
    } else {
      if (this.impersonateUserIdForReport) {
        this.subscription.add(
          this.store$.pipe(select(selectors.getAndFilterAllImpersonatesUsers(this.filterString))).subscribe((res) => {
            const newArr = res.map((element) => ({
              ...element,
              isRunning: false,
              isAccess: true,
            }));
            this.clientGroups = newArr;
            this.cd.detectChanges();
          })
        );
      } else {
        this.subscription.add(
          this.store$.pipe(select(selectors.getAndFilterAllUsers(this.filterString))).subscribe((res) => {
            const newArr = res.map((element) => ({
              ...element,
              isRunning: false,
              isAccess: true,
            }));
            this.clientGroups = newArr;
            this.cd.detectChanges();
          })
        );
      }
    }
  }

  getFormUserFormAssociation() {
    this.subscription.add(
      this.documentService
        .getFormUserFormAssociation(this.vaultStateObject?.userId, this.data?.currentFormId, this.vaultStateObject.vaultId)
        .subscribe(
          (res) => {
            if (res) {
              let finalList = [];
              res.forEach((element, index) => {
                let tempEllemt = {
                  ...element,
                  name: '',
                };
                tempEllemt.name = element.form_name;
                finalList.push(tempEllemt);
              });
              this.entitiesItems = finalList;
              this.cd.detectChanges();
            }
          },
          (error: any) => {}
        )
    );
  }
  addVaultForm(item, index) {
    this.dialogRef.close({
      isSuccess: true,
      item: item,
    });
  }
}
